import { Component } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { NotificationDialogData } from 'editing-tool/src/app/shared/notification/notification-dialog-data';

@Component({
    templateUrl: './notification-dialog.component.html',
    standalone: false
})
export class NotificationDialogComponent {

    public header: string;

    public message: string;

    constructor(dialogConfig: DynamicDialogConfig) {
        const data = dialogConfig.data as NotificationDialogData;
        this.message = data.message;
        this.header = data.header;
    }
}
